import { useCallback, useMemo, useState } from 'react';
import CustomChakraButton from '../../../../CustomChakraButton/CustomChakraButton';
import UserProfileLink from '../../../Users/UserProfileLink/UserProfileLink';
import useAuth from '../../../../../hooks/useAuth';
import {
  MessageKidContextInterface,
  MessageParentContextInterface
} from '../../../../../shared/type/message.type';

type ParentMessageContextProps = {
  tenantId?: string;
  parent: MessageParentContextInterface;
  children: MessageKidContextInterface[];
};

export const ParentMessageContext = ({ tenantId, parent, children }: ParentMessageContextProps) => {
  const { auth } = useAuth();
  const [showingAllChildrens, setShowAllChildrens] = useState(false);

  const kidsToShow = useMemo(
    () => (showingAllChildrens ? children : children.slice(0, 2)),
    [showingAllChildrens, children]
  );

  const toggleShowAllChildrens = useCallback(
    () => setShowAllChildrens((prev) => !prev),
    [showingAllChildrens]
  );
  return (
    <div className="text-right">
      <p className="text-gray-500 text-xs">Profile rodzica</p>
      <div className="mt-1 flex justify-end items-center gap-4">
        <UserProfileLink
          href={`/${auth.loggedUserDto.superAdmin ? 'superAdmin/branches' : 'tenantAdmin'}/id/${tenantId}/users/parents/single-parent/${parent.id}/list-of-orders`}
          fullName={`${parent?.firstName} ${parent?.lastName}`}
        />
      </div>
      {children.length > 0 && (
        <div className="text-right">
          <p className="text-gray-500 text-xs">Profile uczniów</p>
          <div className="mt-1 flex items-center gap-4">
            {children.length > 2 && (
              <CustomChakraButton
                hierarchy="linkGray"
                size="sm"
                iconPosition="onlyText"
                buttonProps={{
                  onClick: toggleShowAllChildrens
                }}>
                {showingAllChildrens ? 'Ukryj' : <> +{children.length - 2}</>}
              </CustomChakraButton>
            )}
            {kidsToShow.map((kid) => (
              <UserProfileLink
                key={kid.id}
                href={`/${auth.loggedUserDto.superAdmin ? 'superAdmin/branches' : 'tenantAdmin'}/id/${tenantId}/users/children/single-kid/${kid.id}/orders`}
                fullName={`${kid.firstName} ${kid.lastName}`}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
